import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
          <p className="text-xl font-semibold text-foreground mb-4">Er ging iets mis</p>
          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2.5 rounded-[6px] bg-primary text-primary-foreground font-medium hover:opacity-90 transition-opacity"
          >
            Pagina herladen
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
